import HandWritingLink from './hand-writing'

/**
 * テキスト入力の基本的な directive.link を実現するクラス。
 * HandWritingDirective から派生する。
 * 
 * [依存関係]
 * HandWritingLink
 */
export default class TextHandWritingLink extends HandWritingLink{
  /**
   * createRegistOption上書き
   * @param {*} scope 
   * @param {*} element 
   * @param {*} attrs 
   * @param {*} ctrl 
   */
  createRegistOption (scope, element, attrs, ctrl) {
    const option = super.createRegistOption(scope, element, attrs, ctrl);

    option.recognitionParams = Object.assign(option.recognitionParams || {}, {
      type: 'TEXT',
      iink: {
        text: {
          guides: {
            enable: false
          },
          smartGuide: false,
          // mimeTypes: ['text/plain', 'application/vnd.myscript.jiix'],//=defaultなので不要
          mimeTypes: ['application/vnd.myscript.jiix'],
          configuration: { 
          }
        },
        export: {
          jiix: {
            "bounding-box": true,
            strokes: true,
            text: {
              chars: true
            }
          }
        },
        // lang: attrs.language,
      }
    });

    return option;
  }
}
